import queryString from 'query-string';
import { getAddressLabel } from './AddressService';

const AT_WEBSITE_URL = process.env.REACT_APP_AT_WEBSITE_URL || 'https://at.govt.nz/';
const JP_URL = `${AT_WEBSITE_URL}bus-train-ferry/journey-planner/`;

const getJourneyPlannerLink = (origin, destination) => {
  if (!origin || !destination) {
    return null;
  }

  const queryObject = {
    fromAddress: getAddressLabel(origin),
    fromCoordinates: `${origin.lat},${origin.lng}`,
    toAddress: getAddressLabel(destination),
    toCoordinates: `${destination.lat},${destination.lng}`,
  };

  return `${JP_URL}?${queryString.stringify(queryObject)}`;
};

export default {
  getJourneyPlannerLink,
};